export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_akhi.png",
      alt: "Nome da extensão",
    },
    title: "Pescando Tendências",
    text: [
      "Portfólio com quatro robôs independentes que operam WINFUT no M5, com melhor desempenho em mercados com tendência ou reversões bem definidas. A estratégia passa a maior parte do tempo com pequenas variações de saldo e rebaixamento médio de 20%, sendo compensada por dias pontuais de forte lucro. Desde julho de 2024, o retorno acumulado é de +102,24%, com dados atualizados em 31/12/2025. ",
    ],
    testimonial: {
      text: "Desenvolvemos estratégias consistentes que geram valor real à sociedade. É isso que nos motiva.",
      author: {
        name: "Israel Araujo, CEO da AKHI",
        // "picture": "https://i.pravatar.cc/150?img=70"
      },
    },
  },
  stats: {
    title: "Um pouco sobre a AKHI",
    subtitle: "Mais de 13 anos de experiência desenvolvendo robôs",
    data: [
      {
        value: "+10",
        description: "Anos de pesquisa",
      },
      {
        value: "+60%",
        description: "de lucro de meta anual",
      },
      {
        value: "35%",
        description: "de risco máximo assumido",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da AKHI?",
    subtitle: "Veja quais as principais vantagens dos robôs da AKHI.",
    data: [
      {
        title: "Teste por 7 dias",
        description: "Valide a estratégia antes de ir para a conta real.",
      },
      {
        title: "Automação total",
        description: "Sinais e ordens 100% pelo robô; zero viés emocional.",
      },
      {
        title: "Regras claras",
        description: "Sem preço médio; stop fixo e alvo definidos desde a entrada.",
      },
      {
        title: "Serenidade e consistência",
        description: "Sem “dia de fúria”; disciplina programada em todos os pregões.",
      },
      {
        title: "Tempo a seu favor",
        description: "Execução automática: foque em outros projetos enquanto o robô opera.",
      },
      {
        title: "Gestão consciente",
        description: "Respeite o risco proposto e deixe o fluxo do mercado acontecer.",
      },
    ],
  },
  cta: {
    title: "Pronto para diversificar?",
    subtitle: "Ative o nosso portfólio na sua carteira",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A AKHI",
    col1: [
      "A AKHI é especializada no desenvolvimento de robôs e em comércio internacional. Com mais de 13 anos criando estratégias para o mercado futuro, tornamos público um portfólio de quatro robôs complementares, desenhados para se adaptar à dinâmica diária do mercado e potencializar resultados com disciplina, tecnologia e gestão de risco. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da AKHI",
  },
  strategies: {
    title: "Um portfólio consistente",
    heading: "Quatro robôs que atuam de maneira independente ",
    subtitle: "Consistência e gestão de risco com retorno de +102,24% (jul/24 - dez/25)",
  },
  testimonials: [
    {
      text: "Os robôs Pescando Tendencias têm dado um resultado muito bom, com risco controlado e qualquer dúvida tem sido prontamente atendida pelo suporte. Recomendo!",
      author: "Pasquale Gerardo",
      job: "Aposentado",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "Uso as estratégias há um tempo e confio muito no potencial das automações. Com visão de longo prazo, respeitando e tolerando momentos de DD é possível ganhar e ter bons rendimentos com as estratégias. Foram meses positivos e negativos, afinal isso aqui é day trade, mas os meses positivos compensam os negativos, recomendo e continuarei usando! ",
      author: "Bruno Ribeiro",
      job: "Assessor de Investimentos",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
  ],
};
